<template>
  <Slide :crossIcon="false" class="is-hidden-desktop">
    <a href="#about" v-scroll-to="'#about'">
      <span class="is-family-secondary">About</span>
    </a>
    <a href="#services" v-scroll-to="'#services'">
      <span>Services</span>
    </a>
    <a href="#latest" v-scroll-to="'#latest'">
      <span>Latest Work</span>
    </a>
    <a href="#contact" v-scroll-to="'#contact'">
      <span>Contact</span>
    </a>
  </Slide>
</template>

<script>
import Vue from 'vue'
import { Slide } from 'vue-burger-menu'

export default {
  name: 'MobileNav',
  components: {
    Slide,
  },
}
</script>

<style lang="scss" scoped>
@import url("./../styles/bm-style.scss");
</style>
